import {appAPI} from "../../../api";
import {IIssuerSettings, IUpsertIssuerSettings} from "../../../models/IIssuerSettings";

const basePath = `/issuer-settings`;

export const issuerSettingsAPI = {
    get: async (): Promise<IIssuerSettings | null> => {
        const res = await appAPI.get(basePath);
        return res.data;
    },

    upsert: async (dto: IUpsertIssuerSettings): Promise<IIssuerSettings> => {
        const res = await appAPI.put(basePath, dto);
        return res.data;
    },
};